import React from 'react';
import styled from 'styled-components';
import { Icon, Loader, Button } from 'oxyrion-ui/lib';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import Checkbox from 'oxyrion-ui/lib/Checkbox';
import { __ } from '../../Utils';
import { connect } from '../../Store';
import { LoaderWrapper } from '../../Components/ReusableComponents';
import DataTable from '../../Components/Table';
import IconTd from '../../Components/ReusableComponents/IconTd';
import AddNewAddress from '../../Components/AddNewAddress';
import PopUpWrapper from '../../Components/PopUpWrapper';
import API2 from '../../API2';

const MainWrapper = styled.div``;

const Wrapper = styled.div`
  margin-left: 16px;
  margin-right: 16px;
  margin-top: 16px;
  background: #eee;
  padding: 16px;
`;

const TableWrapper = styled.div`
  margin-left: 16px;
  margin-right: 16px;
  margin-top: 16px;
  padding: 16px;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: left;
  text-align: left;
  justify-content: left;
  margin-bottom: ${rem(24)};
  height: ${rem(36)};
`;

const TitleIcon = styled(Icon)`
  margin-right: ${rem(16)};
`;

const SegmentWrapper = styled.div`
  min-width: ${rem(432)};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: ${rem(8)};
  margin-bottom: ${rem(16)};
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  font-size: ${rem(26)};
  font-weight: 400;
  color: #434245;
`;

const Row = styled.div`
  display: flex;
  width: 100%;

  font-size: ${rem(14)};
  margin-bottom: ${rem(8)};
`;

const Label = styled.div`
  width: ${rem(150)};
  margin-left: ${rem(50)};
`;

const Text = styled.div`
  font-weight: bold;
`;

const P = styled.p`
  margin: 0;
  padding: 0 ${rem(10)};
  font-size: ${rem(12)};
  height: ${rem(32)};
  display: flex;
  align-items: center;
`;

const Delete = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${rem(40)};
`;

const Edit = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${rem(40)};
`;

const ButtonWrapper = styled.div`
  padding: ${rem(10)} 0;
  display: flex;
  justify-content: left;
  align-items: center;
`;

class AccountDetail extends React.Component {
  state = {
    data: {},
    loading: true,
    showAddNewAddressPopup: false,
    defaultAddressId: '',
  };

  componentDidMount() {
    this.fetchData();
  }

  async setDefaultAddress(addressId) {
    try {
      await API2.putB2BDefaultAddress(addressId);

      this.setState({
        defaultAddressId: addressId,
      });
    } catch (e) {
      console.log(e);
    }
  }

  getAddressById(addressId) {
    const { addresses } = this.state;

    const addressToEdit = addresses.find(address => address._id === addressId);

    return addressToEdit;
  }

  async fetchData() {
    try {
      const result = await API2.getB2BCustomerAction();

      const addresses = await API2.getB2BAddresses();

      this.setState({
        data: result,
        addresses: addresses.addresses || [],
        loading: false,
        defaultAddressId: addresses.default_address_id || '',
      });
    } catch (e) {
      console.log(e);
    }
  }

  createColumns() {
    return [
      {
        accessor: 'name',
        Header: () => <IconTd>{__('Meno/Firma')}</IconTd>,
        Cell: props => {
          return <P>{props.value ? props.value : '-'}</P>;
        },
      },
      {
        accessor: 'street',
        Header: () => <IconTd>{__('Ulica')}</IconTd>,
        Cell: props => {
          return <P>{props.value ? props.value : '-'}</P>;
        },
      },
      {
        accessor: 'city',
        Header: () => <IconTd>{__('Mesto')}</IconTd>,
        Cell: props => {
          return <P>{props.value ? props.value : '-'}</P>;
        },
      },
      {
        accessor: 'postal_code',
        Header: () => <IconTd>{__('PSČ')}</IconTd>,
        Cell: props => {
          return <P>{props.value ? props.value : '-'}</P>;
        },
      },
      {
        accessor: 'country',
        Header: () => <IconTd>{__('Krajina')}</IconTd>,
        Cell: props => {
          return <P>{props.value}</P>;
        },
      },
      {
        accessor: 'contact_person',
        Header: () => <IconTd>{__('Kontaktná osoba')}</IconTd>,
        Cell: props => {
          return <P>{props.value ? props.value : '-'}</P>;
        },
      },
      {
        accessor: 'phone',
        Header: () => <IconTd>{__('Tel. Číslo')}</IconTd>,
        Cell: props => {
          return <P>{props.value ? props.value : '-'}</P>;
        },
      },
      {
        accessor: '_id',
        Header: () => <IconTd>{__('Predvolená adresa')}</IconTd>,
        width: 140,
        Cell: props => {
          return (
            <div
              style={{
                alignItems: 'center',
                textAlign: 'center',
                justifyContent: 'center',
              }}
            >
              <Checkbox
                onClick={() =>
                  this.handleAdressChange(props.value, 'setDefault')
                }
                checked={this.state.defaultAddressId === props.value}
              />
            </div>
          );
        },
      },
      {
        accessor: '_id',
        width: 50,
        Cell: props => {
          return (
            <Edit onClick={() => this.handleAdressChange(props.value, 'edit')}>
              <Icon name="pencil" size="m" />
            </Edit>
          );
        },
      },
      {
        accessor: '_id',
        width: 50,
        Cell: props => {
          return (
            <Delete
              onClick={() => this.handleAdressChange(props.value, 'delete')}
            >
              <Icon name="close" size="l" color="red" />
            </Delete>
          );
        },
      },
    ];
  }

  async addNewAddress(address) {
    const addressId = address._id;
    const data = {
      name: address.name,
      street: address.street,
      city: address.city,
      postal_code: address.postal_code,
      country: address.country,
      contact_person: address.contact_person,
      phone: address.phone,
    };
    if (addressId) {
      try {
        await API2.putB2BAddress(addressId, { body: data });
        this.setState({
          showAddNewAddressPopup: false,
        });
      } catch (e) {
        console.log(e);
      }
    } else {
      try {
        await API2.postB2BAddress({
          body: {
            data,
          },
        });
        this.setState({
          showAddNewAddressPopup: false,
        });
      } catch (e) {
        console.log(e);
      }
    }

    this.fetchData();
  }

  async deleteAddress(addressId) {
    try {
      await API2.deleteB2BAddress(addressId);

      this.fetchData();
    } catch (e) {
      console.log(e);
    }
  }

  toggleAddNewAddress() {
    this.setState({
      showAddNewAddressPopup: !this.state.showAddNewAddressPopup,
    });
  }

  handleAdressChange(addressId, action) {
    if (action === 'setDefault') {
      this.setDefaultAddress(addressId);
    } else if (action === 'edit') {
      const addressToEdit = this.getAddressById(addressId);

      this.setState({
        addressToEdit,
      });

      this.toggleAddNewAddress();
    } else if (action === 'delete') {
      this.deleteAddress(addressId);
    }
  }

  render() {
    const {
      data,
      loading,
      addresses,
      showAddNewAddressPopup,
      addressToEdit,
    } = this.state;

    if (loading) {
      return (
        <LoaderWrapper>
          <Loader size="l" />
        </LoaderWrapper>
      );
    }

    return (
      <MainWrapper>
        <PopUpWrapper
          display={showAddNewAddressPopup}
          message={__('Doručovacia adresa')}
          customWidth={360}
          onClose={() => this.toggleAddNewAddress()}
          onEscClose={() => this.toggleAddNewAddress()}
        >
          <AddNewAddress
            onAdd={address => this.addNewAddress(address)}
            addressToEdit={addressToEdit}
          />
        </PopUpWrapper>
        <Wrapper>
          <Row>
            <SegmentWrapper>
              <TitleWrapper>
                <TitleIcon name="home" size="xl" color="#70af00" />
                <Title>{__('Firemné údaje')}</Title>
              </TitleWrapper>
              <Row>
                <Label>{__('Firma:')}</Label>
                <Text>{data.name}</Text>
              </Row>

              <Row>
                <Label>{__('IČO:')}</Label>
                <Text>{data.registration_no}</Text>
              </Row>

              <Row>
                <Label>{__('DIČ:')}</Label>
                <Text>{data.vat_nr.replace('SK', '')}</Text>
              </Row>

              <Row>
                <Label>{__('IČ DPH:')}</Label>
                <Text>{data.vat_nr}</Text>
              </Row>
            </SegmentWrapper>

            <SegmentWrapper>
              <TitleWrapper />
              <Row>
                <Label>{__('Tel:')}</Label>
                <Text>{data.phone}</Text>
              </Row>

              <Row>
                <Label>{__('Email:')}</Label>
                <Text>{data.email}</Text>
              </Row>
            </SegmentWrapper>
          </Row>

          <Row>
            {/* <SegmentWrapper>
              <TitleWrapper>
                <TitleIcon name="mail" size="xl" color="#70af00" />
                <Title>{__('Doručovacia adresa')}</Title>
              </TitleWrapper>

              <Row>
                <Label>{__('Meno/Firma:')}</Label>
                <Text>{data.name}</Text>
              </Row>

              <Row>
                <Label>{__('Ulica:')}</Label>
                <Text>{data.delivery_address.street}</Text>
              </Row>
              <Row>
                <Label>{__('Mesto:')}</Label>
                <Text>{data.delivery_address.city}</Text>
              </Row>
              <Row>
                <Label>{__('PSČ:')}</Label>
                <Text>{data.delivery_address.postal_code}</Text>
              </Row>
              <Row>
                <Label>{__('Krajina:')}</Label>
                <Text>{data.delivery_address.country}</Text>
              </Row>
            </SegmentWrapper> */}

            <SegmentWrapper>
              <TitleWrapper>
                <TitleIcon name="article" size="xl" color="#70af00" />
                <Title>{__('Fakturačná adresa')}</Title>
              </TitleWrapper>

              <Row>
                <Label>{__('Meno/Firma:')}</Label>
                <Text>{data.name}</Text>
              </Row>

              <Row>
                <Label>{__('Ulica:')}</Label>
                <Text>{data.billing_address.street}</Text>
              </Row>
              <Row>
                <Label>{__('Mesto:')}</Label>
                <Text>{data.billing_address.city}</Text>
              </Row>
              <Row>
                <Label>{__('PSČ:')}</Label>
                <Text>{data.billing_address.postal_code}</Text>
              </Row>
              <Row>
                <Label>{__('Krajina:')}</Label>
                <Text>{data.billing_address.country}</Text>
              </Row>
            </SegmentWrapper>
          </Row>
        </Wrapper>
        <TableWrapper>
          <TitleWrapper>
            <TitleIcon name="mail" size="xl" color="#70af00" />
            <Title>{__('Doručovacie adresy')}</Title>
          </TitleWrapper>
          <DataTable
            noDataText={__('Nenašli sa žiadne adresy')}
            minWidth={10}
            data={addresses}
            columns={this.createColumns()}
            pageSize={addresses && addresses.length ? addresses.length : 10}
            getTdProps={() => {
              return { style: { padding: 0, margin: 'auto' } };
            }}
            className="-highlight -striped"
            style={{ border: 'none' }}
            getTrProps={(state, rowInfo) => {
              if (rowInfo && rowInfo.row) {
                return {
                  style: {
                    backgroundColor: rowInfo.index % 2 === 0 ? 'white' : '#eee',
                    cursor: 'pointer',
                  },
                };
              }
              return {};
            }}
          />
          <ButtonWrapper>
            <Button
              onClick={() => {
                this.setState({ addressToEdit: {} });
                this.toggleAddNewAddress();
              }}
              primary
            >
              {__('Nová adresa')}
            </Button>
          </ButtonWrapper>
        </TableWrapper>
      </MainWrapper>
    );
  }
}

AccountDetail.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    surname: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    role: PropTypes.string,
  }),
};

AccountDetail.defaultProps = {
  user: {
    name: '',
    surname: '',
    email: '',
    phone: '',
    role: '',
  },
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(AccountDetail);



// WEBPACK FOOTER //
// ./src/Containers/CompanyDetails/index.jsx